/* eslint-disable max-len */
import { Component } from 'react';

import {
  ClipPath,
  Defs,
  G,
  Path,
  Svg,
} from '../../../utils/packages/reactNativeSvg';

interface Props {
  id?: string;
}
interface DefaultProps {
  id: string;
}
export default class IconCartEmpty extends Component<Props> {
  static defaultProps: DefaultProps = {
    id: Math.random().toString(),
  };
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { id } = this.props;

    return (
      <Svg width={40} height={40} viewBox="0 0 40 40">
        <Defs>
          <ClipPath id={`clip-path-${id}`}>
            <Path
              fill="none"
              d="M22.07 25.1h-4.14v7.22a2.07 2.07 0 1 0 4.14 0z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-2-${id}`}>
            <Path fill="none" d="M-157.84-117.03h356.95v634.89h-356.95z" />
          </ClipPath>
          <ClipPath id={`clip-path-3-${id}`}>
            <Path
              fill="none"
              d="M34.25 38.79a2.17 2.17 0 0 1-2.88-1l-4.06-8.53-2.13-4.49 3.9-1.86 1.62 3.39 4.57 9.61a2.17 2.17 0 0 1-1.02 2.88z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-5-${id}`}>
            <Path
              fill="none"
              d="M14.82 24.75L11.9 30.9l-3.27 6.87a2.16 2.16 0 1 1-3.9-1.86l3.36-7.07 2.83-5.95z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-7-${id}`}>
            <Path
              fill="none"
              d="M10.92 22.89l3.9 1.86-2.92 6.15a17.29 17.29 0 0 1-3.81-2.06z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-9-${id}`}>
            <Path
              fill="none"
              d="M30.7 26.3a17 17 0 0 1-3.39 2.94l-2.13-4.49 3.9-1.86z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-11-${id}`}>
            <Path fill="none" d="M3 11a17 17 0 0 0 34 0" />
          </ClipPath>
          <ClipPath id={`clip-path-13-${id}`}>
            <Path
              fill="none"
              d="M20 28A17 17 0 0 1 3 11h9.09c.02 9.42 3.55 17 7.91 17z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-15-${id}`}>
            <Path
              fill="none"
              d="M37 7.86V11c0 3.79-7.6 6.86-17 6.86a39.12 39.12 0 0 1-7.35-.67C7 16.12 3 13.77 3 11V7.86z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-17-${id}`}>
            <Path fill="none" d="M12.65 7.86v9.37C7 16.12 3 13.77 3 11V7.86z" />
          </ClipPath>
          <ClipPath id={`clip-path-19-${id}`}>
            <Path
              fill="none"
              d="M37 7.86c0 1.43-1.08 2.75-2.91 3.85-3.05 1.82-8.22 3-14.07 3s-11-1.2-14.07-3C4.1 10.61 3 9.29 3 7.86 3 4.07 10.62 1 20 1s17 3.07 17 6.86z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-21-${id}`}>
            <Path
              fill="none"
              d="M35.37 7.86c0 .77-.77 1.67-2.12 2.47a10.17 10.17 0 0 1-.93.5A25.89 25.89 0 0 1 23.68 13c-.59.06-1.2.1-1.82.13s-1.23 0-1.86 0a40.47 40.47 0 0 1-4.19-.22l-1.51-.19a26.75 26.75 0 0 1-5-1.22c-.42-.15-.83-.31-1.21-.49l-.39-.18a10.17 10.17 0 0 1-.93-.5c-1.35-.8-2.12-1.7-2.12-2.47 0-1.08 1.52-2.37 4-3.36a27.64 27.64 0 0 1 7.72-1.73c.59-.06 1.2-.1 1.82-.13s1.23 0 1.86 0a40.82 40.82 0 0 1 4.2.22c.51.05 1 .12 1.5.19a27.23 27.23 0 0 1 5 1.22l.69.27.53.22c2.1.91 3.4 2.1 3.4 3.1z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-23-${id}`}>
            <Path
              fill="none"
              d="M32.32 10.83c-3 1.45-7.48 2.3-12.32 2.3s-9.34-.85-12.32-2.3A32.58 32.58 0 0 1 20 8.69a32.58 32.58 0 0 1 12.32 2.14z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-25-${id}`}>
            <Path
              fill="none"
              d="M25.7 3l-9.89 9.9-1.51-.19 9.9-9.9c.51.06 1.01.13 1.5.19z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-27-${id}`}>
            <Path
              fill="none"
              d="M18.14 2.64L9.28 11.5c-.42-.15-.83-.31-1.21-.49l8.25-8.24c.59-.06 1.2-.1 1.82-.13z"
            />
          </ClipPath>
          <ClipPath id={`clip-path-29-${id}`}>
            <Path
              fill="none"
              d="M31.93 4.72L23.68 13c-.59.06-1.2.1-1.82.13l8.85-8.86.69.27z"
            />
          </ClipPath>
        </Defs>
        <G clipPath={`url(#clip-path-${id})`}>
          <Path fill="#595757" d="M13.17 20.34h13.66v18.81H13.17z" />
        </G>
        <G clipPath={`url(#clip-path-3-${id})`}>
          <Path fill="#777575" d="M20.42 18.13h19.82v25.63H20.42z" />
        </G>
        <G clipPath={`url(#clip-path-5-${id})`}>
          <Path fill="#777575" d="M-.24 18.13h19.82v25.63H-.24z" />
        </G>
        <G clipPath={`url(#clip-path-7-${id})`}>
          <Path fill="#595757" d="M3.33 18.13h16.25v17.52H3.33z" />
        </G>
        <G clipPath={`url(#clip-path-9-${id})`}>
          <Path fill="#595757" d="M20.42 18.13h15.04V34H20.42z" />
        </G>
        <G clipPath={`url(#clip-path-11-${id})`}>
          <Path fill="#777575" d="M-1.73 6.28h43.47v26.49H-1.73z" />
        </G>
        <G clipPath={`url(#clip-path-13-${id})`}>
          <Path fill="#595757" d="M-1.73 6.28h26.49v26.49H-1.73z" />
        </G>
        <G clipPath={`url(#clip-path-15-${id})`}>
          <Path fill="#939090" d="M-1.74 3.11h43.47v19.56H-1.74z" />
        </G>
        <G clipPath={`url(#clip-path-17-${id})`}>
          <Path fill="#777575" d="M-1.74 3.11h19.15v18.88H-1.74z" />
        </G>
        <G clipPath={`url(#clip-path-19-${id})`}>
          <Path fill="#595757" d="M-1.74-3.76h43.47v23.25H-1.74z" />
        </G>
        <G clipPath={`url(#clip-path-21-${id})`}>
          <Path fill="#ff4440" d="M-.13-2.16h40.27v20.04H-.13z" />
        </G>
        <G clipPath={`url(#clip-path-23-${id})`}>
          <Path fill="#ea2f2f" d="M2.92 3.93h34.16v13.96H2.92z" />
        </G>
        <G clipPath={`url(#clip-path-25-${id})`}>
          <Path fill="#595757" d="M9.54-1.94h20.92v19.61H9.54z" />
        </G>
        <G clipPath={`url(#clip-path-27-${id})`}>
          <Path fill="#595757" d="M3.31-2.12H22.9v18.37H3.31z" />
        </G>
        <G clipPath={`url(#clip-path-29-${id})`}>
          <Path fill="#595757" d="M17.1-.53h19.58v18.37H17.1z" />
        </G>
      </Svg>
    );
  }
}
